<app-expandible-title [title]="'Carteira'"></app-expandible-title>

<div>
    <span>Nome: </span>
    <span class="font-weight-bold">{{data?.nome}}</span>
</div>

<div>
    <span>Nome completo: </span>
    <span class="font-weight-bold">{{data?.nomeCompleto}}</span>
</div>

<div>
    <span>CNPJ: </span>
    <span class="font-weight-bold">{{formatCnpj(data?.cnpj)}}</span>
</div>


<div>
    <span>Ativa: </span>
    <span class="font-weight-bold">{{data?.ativa ? 'Sim' : 'Não'}}</span>
</div>

<div>
    <span>Processamento automático: </span>
    <span class="font-weight-bold">{{data?.auto ? 'Sim' : 'Não'}}</span>
</div>

